module.exports = __webpack_public_path__ + "static/media/5-5.7d8a21d0.mp3";